import type { LocationData, LocationType } from '@/app/_shared/store/type';
import { atom } from 'jotai';
import { setCookie } from 'cookies-next/client';
import { toZonedTime } from 'date-fns-tz';
import { LOCATION_TYPE } from '@/app/_shared/store/type';
import { cookieKey } from '@/app/(pages)/local/constants';

export const DEFAULT_LOCATION = {
  latitude: '37.56657',
  longitude: '126.97817',
  locationType: LOCATION_TYPE.DEFAULT as LocationType,
  locationTime: Math.floor(toZonedTime(new Date(), 'Asia/Seoul').getTime() / 1000),
  hasPermissionError: true,
  addressOnlyRoad: '위치 확인 중',
  address: '서울특별시 중구 세종대로 110 서울특별시청',
  addressShort: '서울특별시청',
};

// 쿠키에 위치 정보를 저장하는 함수
export const setCookieLocation = (location: Partial<LocationData>) => {
  if (typeof window === 'undefined') return;

  const expires = new Date();
  expires.setTime(expires.getTime() + 1000 * 60 * 10); // 10분

  setCookie(cookieKey.LOCATION, JSON.stringify(location), { expires });
};

// 위치 정보를 관리하는 atom
export const localLocationAtom = atom(DEFAULT_LOCATION, (get, set, newLocation: Partial<LocationData>) => {
  if (newLocation === undefined) {
    return;
  }
  set(localLocationAtom, { ...get(localLocationAtom), ...newLocation });
});
